<template>
  <div class="info">
    i
    <div class="tooltip">
      <p><slot /></p>
    </div>
  </div>
</template>

<style scoped>
.info {
  position: relative;
  display: inline-block;
  height: 1em;
  width: 1em;
  color: black;
  background-color: lightgray;
  border: none;
  border-radius: 50%;

  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.tooltip {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.3s;
  position: absolute;
  left: -100px;
  top: calc(100% + 16px);
  width: 305px;
  height: 94px;
  padding: 0.3em 1em;

  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 15px;
  color: #000;
  background-color: #fff;
  z-index: 1;

  border: 4px solid #8dc54e;
  border-radius: 18px;
}

.tooltip::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 96px;
  border-width: 16px;
  border-left-width: 8px;
  border-right-width: 8px;
  border-style: solid;
  border-color: transparent transparent #8dc54e transparent;
}

.info:hover .tooltip {
  visibility: visible;
  opacity: 1;
}
</style>
